var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { IndicatorLabel } from './indicator-label';
var cls = classNames('indicator-block-layout');
var IndicatorBlockLayoutDefaultProps = {
  variant: 'default',
  dataViz: null
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(5))
});
var InfoStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    font-size: 1.5em;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    font-size: 1.5em;\n  "])), theme.UNIT(1))
});
var ResultStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(1))
});
var IndicatorLabelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SupportingIndicatorStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    color: ", ";\n  "], ["\n    display: flex;\n    color: ", ";\n  "])), theme.COLOR('text-mid'))
});
var TextualIndicatorStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TextualTitleStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin: 0;\n    color: ", ";\n    font-size: 0.8em;\n    font-weight: 300;\n  "], ["\n    margin: 0;\n    color: ", ";\n    font-size: 0.8em;\n    font-weight: 300;\n  "])), theme.COLOR('strong'))
});
var IndicatorAndYearStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var IndicatorStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    text-transform: uppercase;\n  "], ["\n    text-transform: uppercase;\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin: 0;\n    color: ", ";\n    font-weight: 500;\n  "], ["\n    margin: 0;\n    color: ", ";\n    font-weight: 500;\n  "])), theme.COLOR('strong'))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin: 0;\n    color: ", ";\n    font-weight: 300;\n  "], ["\n    margin: 0;\n    color: ", ";\n    font-weight: 300;\n  "])), theme.COLOR('text-mid'))
});
var YearStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 300;\n\n    ", "\n  "], ["\n    color: ", ";\n    font-weight: 300;\n\n    ", "\n  "])), theme.COLOR('text-subtle'), function (_a) {
    var variant = _a.variant;
    return variant === 'valueFirst' && css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      font-size: 0.8em;\n    "], ["\n      font-size: 0.8em;\n    "])));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinksStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(2))
});
var LinkStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.COLOR('text-mid'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Info: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Results: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ResultStyles),
  IndicatorLabel: styled(IndicatorLabel)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), IndicatorLabelStyles),
  SupportingIndicator: styled.span(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), SupportingIndicatorStyles),
  TextualIndicator: styled.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), TextualIndicatorStyles),
  TextualTitle: styled.h4(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), TextualTitleStyles),
  IndicatorAndYear: styled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), IndicatorAndYearStyles),
  Indicator: styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), IndicatorStyles),
  Title: styled.h2(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: styled.h2(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Year: styled.span(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), YearStyles),
  Body: styled.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Links: styled.div(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), LinksStyles),
  Link: styled.a(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
export var IndicatorBlockLayout = function (props) {
  var _a, _b;
  var className = props.className,
    children = props.children,
    variant = props.variant,
    dataViz = props.dataViz,
    entity = props.entity;
  var _c = entity.result,
    result = _c === void 0 ? {} : _c,
    _d = entity.supportingIndicators,
    supportingIndicators = _d === void 0 ? [] : _d,
    title = entity.title,
    subtitle = entity.subtitle,
    name = entity.name;
  var year = result.year,
    numericValue = result.numericValue,
    _e = result.links,
    links = _e === void 0 ? [] : _e;
  var unitToDisplay = ((_a = entity === null || entity === void 0 ? void 0 : entity.unit) === null || _a === void 0 ? void 0 : _a.shorthand) || ((_b = entity === null || entity === void 0 ? void 0 : entity.unit) === null || _b === void 0 ? void 0 : _b.name) || '';
  var showInlineYear = props.showInlineYear === undefined ? unitToDisplay.length < 10 : props.showInlineYear;
  var hasTitle = !!title || !!name;
  var hasSubtitle = !!subtitle;
  var hasSupportingIndicators = !!supportingIndicators.length;
  var hasYear = !!year;
  var hasDataViz = !!dataViz;
  var hasLinks = !!links.length;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, variant === 'valueFirst' ? React.createElement(My.Info, null, React.createElement(My.Results, null, React.createElement(My.IndicatorLabel, {
    entity: entity
  }), hasSupportingIndicators && supportingIndicators.map(function (indicator) {
    var _a;
    return ((_a = indicator === null || indicator === void 0 ? void 0 : indicator.result) === null || _a === void 0 ? void 0 : _a.value) && React.createElement(My.SupportingIndicator, null, "(", React.createElement(My.IndicatorLabel, {
      entity: indicator
    }), ")");
  }), hasYear && showInlineYear && React.createElement(My.Year, {
    variant: 'valueFirst'
  }, "(", year, ")")), hasYear && !showInlineYear && React.createElement(My.Year, {
    variant: 'valueFirst'
  }, "(", year, ")"), React.createElement(My.TextualIndicator, null, hasTitle && React.createElement(My.TextualTitle, null, title || name))) : React.createElement(My.IndicatorAndYear, null, React.createElement(My.Indicator, null, hasTitle && React.createElement(My.Title, null, title || name), hasSubtitle && React.createElement(My.Subtitle, null, subtitle)), hasYear && React.createElement(My.Year, null, "(", year, ")")), hasDataViz && React.createElement(My.Body, null, dataViz), React.createElement(My.Links, null, hasLinks && links.map(function (link) {
    return React.createElement(My.Link, {
      target: "_blank",
      href: link.url
    }, (link === null || link === void 0 ? void 0 : link.title) || link.name);
  })), children);
};
IndicatorBlockLayout.defaultProps = IndicatorBlockLayoutDefaultProps;
IndicatorBlockLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31;